export const scrollToPricing = () => {
  const el = document.getElementById('precios')
  if (el) {
    const y = el.getBoundingClientRect().top + window.scrollY - 40
    window.scrollTo({ top: y, behavior: 'smooth' })
  }
}
